/**
 * Returns the renderable columns of a schema, excluding the special `@`
 * default action entry.
 * @function getColumns
 * @since 1.0.0
 */
export function getColumns(schema) {
    return Object.keys(schema).filter((column) => column != '@' && schema[column]);
}
/**
 * Returns the default row action defined by the special `@` entry.
 * @function getDefaultAction
 * @since 1.0.0
 */
export function getDefaultAction(schema, value) {
    var _a;
    return (_a = schema['@']) === null || _a === void 0 ? void 0 : _a.render(value);
}
/**
 * Indicates whether a column should shrink to its content, either
 * explicitly (`width: 'min'`) or by type (`image`, `actions`).
 * @function isMinWidth
 * @since 1.0.0
 */
export function isMinWidth(label) {
    if (label == null) {
        return false;
    }
    if (label.width) {
        return label.width == 'min';
    }
    return label.type == 'image' || label.type == 'actions';
}
/**
 * Resolves the CSS width of a column from its schema definition.
 * @function getColumnWidth
 * @since 1.0.0
 */
export function getColumnWidth(label) {
    if (isMinWidth(label)) {
        return '1%';
    }
    return label === null || label === void 0 ? void 0 : label.width;
}
/**
 * Resolves the alignment of a column, falling back on a default suited
 * to its type.
 * @function getColumnAlign
 * @since 1.0.0
 */
export function getColumnAlign(label) {
    if (label === null || label === void 0 ? void 0 : label.align) {
        return label.align;
    }
    if ((label === null || label === void 0 ? void 0 : label.type) == 'number' || (label === null || label === void 0 ? void 0 : label.type) == 'money') {
        return 'right';
    }
    return undefined;
}
